// Angular
import { OnInit } from '@angular/core';
import { Component } from '@angular/core';

// Formly
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-checkbox',
    templateUrl: './checkbox.type.component.html',
})
export class FormlyFieldCheckBox extends FieldType implements OnInit {
    defaultOptions = {
        templateOptions: {
            options: [],
            formCheck: 'custom', // 'custom' | 'stacked' | 'inline'
        },
    };

    public ngOnInit(): void {

    }
}
